import type { PromptTemplate, PromptValues } from './types';
import { createPromptValues } from './engine';
import { migratePromptDraftValue } from './draft-value-migrations';

const prefix = 'designforge:prompt-draft:v1:';
const storageKey = (template: PromptTemplate) => `${prefix}${template.id}${template.draftVersion ? `:v${template.draftVersion}` : ''}`;

export const promptDraftRepository = {
  read(template: PromptTemplate): PromptValues {
    const defaults = createPromptValues(template);
    try {
      const saved = window.localStorage.getItem(storageKey(template));
      if (!saved) return defaults;
      const parsed: unknown = JSON.parse(saved);
      if (!parsed || typeof parsed !== 'object' || Array.isArray(parsed)) return defaults;
      return Object.fromEntries(template.fields.map(field => {
        const value = (parsed as Record<string, unknown>)[field.key];
        return [field.key, typeof value === 'string' ? migratePromptDraftValue(template.id, field.key, value) : defaults[field.key]];
      }));
    } catch {
      return defaults;
    }
  },
  write(template: PromptTemplate, values: PromptValues) {
    try { window.localStorage.setItem(storageKey(template), JSON.stringify(values)); } catch { /* Storage is optional. */ }
  },
  clear(template: PromptTemplate) {
    try { window.localStorage.removeItem(storageKey(template)); } catch { /* Storage is optional. */ }
  },
};
